import {
  GetPartnerBusinessProfileResponse,
  PutPartnerBusinessProfileRequest,
} from '../../../api/type/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface BusinessDaysType {
  dayOfWeek: number;
  active: boolean;
}

interface BusinessProfileState {
  businessProfile: GetPartnerBusinessProfileResponse | null;
  putBusinessProfile: GetPartnerBusinessProfileResponse | null;
  lagnModalOpen: boolean; // 언어 선택 모달
}

const initialState: BusinessProfileState = {
  businessProfile: null,
  putBusinessProfile: null,
  lagnModalOpen: false,
};

export const businessProfileSlice = createSlice({
  name: 'businessProfile',
  initialState,
  reducers: {
    setBusinessProfile: (
      state,
      action: PayloadAction<GetPartnerBusinessProfileResponse>
    ) => {
      state.businessProfile = action.payload;
    },
    putBusinessProfile: (
      state,
      action: PayloadAction<Partial<GetPartnerBusinessProfileResponse> | null>
    ) => {
      if (action.payload === null) {
        state.putBusinessProfile = null;
        return;
      }
      state.putBusinessProfile = {
        ...state.putBusinessProfile!,
        ...action.payload,
      };
    },
    setLangModalOpen: (state, action: PayloadAction<boolean>) => {
      state.lagnModalOpen = action.payload;
    },
  },
});

export const businessProfile = businessProfileSlice.actions;
export default businessProfileSlice.reducer;
